import * as types from '../constants/ActionTypes';

/** The following actions are ment to be called from JawsComponent
 *
 *  If you need to add/update/delete an item, use one of
 *    * `manuallyAddItem()`
 *    * `manuallyUpdateItem()`
 *    * `manuallyDeleteItem()`
 */
export function addItem(component, item) {
  return { type: types.ADD_ITEM, component, item };
}

export function addItems(component, items) {
  return { type: types.ADD_ITEMS, component, items };
}

export function updateItem(component, item) {
  return { type: types.UPDATE_ITEM, component, item };
}

export function deleteItem(component, item) {
  return { type: types.DELETE_ITEM, component, item };
}

export function deleteAllItems(component) {
  return { type: types.DELETE_ALL_ITEMS, component };
}

export function addComponent(component) {
  return { type: types.ADD_COMPONENT, component };
}

export function deleteComponent(component) {
  return { type: types.DELETE_COMPONENT, component };
}

export function componentInitialized(component) {
  return { type: types.COMPONENT_INITIALIZED, component };
}

// TODO actually talk to the API
export function manuallyAddItem(component, item) {
  return dispatch => {
    dispatch(addItem(component, item));
  };
}

export function manuallyUpdateItem(component, item) {
  return dispatch => {
    dispatch(updateItem(component, item));
  };
}

export function manuallyDeleteItem(component, item) {
  return dispatch => {
    dispatch(deleteItem(component, item));
  };
}

export function setTotalSize(component, value) {
  return { type: types.SET_COMPONENT_TOTAL_SIZE, component, value };
}
